import React from "react";
import { useFacility } from "@/context/FacilityContext";
import { PageHeader } from "@/components/common/PageHeader";
import { CrudTable } from "@/components/common/CrudTable";

export default function Departments() {
  const { activeId, has, activeFacility } = useFacility();
  return (
    <div data-testid="departments-page">
      <PageHeader title="Departments" subtitle={activeFacility ? `Clinical and operational departments at ${activeFacility.name}.` : "Select a facility to manage departments."} />
      <CrudTable
        endpoint="departments" facilityId={activeId} entityName="Department" canEdit={has("department:create")}
        testId="departments-crud"
        columns={[{ key: "name", label: "Department" }, { key: "code", label: "Code", mono: true }, { key: "head_name", label: "Head" }]}
        fields={[{ key: "name", label: "Department name", full: true }, { key: "code", label: "Code" }, { key: "head_name", label: "Head" }, { key: "description", label: "Description", full: true }]}
      />
    </div>
  );
}
